export const keyboardBindings = {
    bold: {
        key: 'b',
        shortKey: true,
        handler() {
            return false;
        },
    },
    italic: {
        key: 'i',
        shortKey: true,
        handler() {
            return false;
        },
    },
    underline: {
        key: 'u',
        shortKey: true,
        handler() {
            return false;
        },
    },
    tab: {
        key: 'Tab',
        handler() {
            return false;
        },
    },
};
